import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import createPersistedState from "vuex-persistedstate"
 
Vue.use(Vuex)
const req = require.context('./modules', false, /\.js$/)
// console.log(req, 'req')
// console.log(req.keys(), 'req.keys()')// 模块名的数组
 
// 打印出模块名
const mName = req.keys().map(item => item.split('./')[1]).map(item => item.split('.js')[0])
// console.log(mName, 'mName')
// console.log(req.keys().map(req), 'map')// 所有的modules组成的列表
 
// 遍历模块添加到obj中
const obj = {}
const mMoudle = req.keys().map(req)
 
mName.forEach((item, index) => {
  obj[item] = mMoudle[index].default// 每一个对象
})
 
const store = new Vuex.Store({
  modules: obj,
  getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage
})],
})
 
export default store
